<div class="ui container" appMargin appPadding>
  <div class="ui vertical basic segment" [ngClass]="{ loading: isPending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <label class="sub-item">Home / AI Chatbot </label>
          <h2 class="ui primary header">NCC AI Chat Bot</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="ui basic segment" style="margin: 0; border: 0; padding: 0;">
    <router-outlet></router-outlet>
  </div>
</div>
